import cardInfoStyles from './card-info.module.scss';
import Link from 'next/link';
import { WebPNextImage as Image } from '../../WebPImage';

const articleUrl = '/document';
import request from '../../../utils/request/next-request';
import router from 'next/router';
const icon = '/img/doc-center/docPageFile.webp';
const arrowRight = '/img/doc-center/arrowRight.svg';
import { useUserAgentInfo } from '../../../context/user-agent';

const InfoMobile = ({ item, onClick }) => {
  return (
    <div
      className={cardInfoStyles['container']}
      onClick={() => onClick(item.id, item.productName, item.productCode)}
    >
      <div className={cardInfoStyles.titleInfo}>
        <div className={cardInfoStyles.title}>
          <div className={cardInfoStyles.icon}>
            <Image src={icon} alt="pageIcon" layout="fill" />
          </div>
          <div className={cardInfoStyles.name}>{item.productName}</div>
        </div>
      </div>
      <div className={cardInfoStyles.rightArrow}>
        <Image src={arrowRight} alt="arrowRight.svg" layout="fill" />
      </div>
      <div className={cardInfoStyles.oneLine}></div>
    </div>
  );
};

export default function CardInfo({ item }) {
  const onClick = async (
    productId: string,
    productName: string,
    productCode: string
  ) => {
    router.push(
      `${articleUrl}/${item.productCode}/${item.topDocs?.[0]?.docsKey || ''}`
    );
  };

  return <InfoMobile {...{ item, onClick }} />;
}
